export const InputStyles = {
  Base:
    "flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm " +
    "outline-none border border-input hover:[&:not(:focus-within)]:border-input focus:ring-0 focus:outline-none focus-within:outline-none " +
    "placeholder:text-muted-foreground " +
    "disabled:cursor-not-allowed disabled:opacity-50 " +
    "transition-colors transition-border duration-200 box-border ",
  Input: "h-9 w-full",
  Textarea: "min-h-[60px] [@media(max-height:600px)]:min-h-[36px]",
};
